import { get, post, urlApiTegra } from "../../../service/api";

const url = urlApiTegra;

const getHoursManagement = (token: string) => {
  return get(`${url}/bank-hours`, token);
};

const getHoursManagementByIdUserAndIdProject = (params: string, token: string) => {
  return get(`${url}/bank-hours/statement${params}`, token);
};

const debitHours = (body: any, token: string) => {
  return post(`${url}/bank-hours/debit`, body, token);
};

export { getHoursManagement, getHoursManagementByIdUserAndIdProject, debitHours };
